import { Box, Stack, Typography, theme } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { UsedBySectionData } from '../types'
import Image from 'next/image'

//sectionId is used for navigation
const UsedBySection: FC<{ data?: UsedBySectionData; dark?: boolean; sectionId?: string }> = ({
  data,
  dark,
  sectionId
}) => {
  if (!data) return null
  return (
    <Box
      sx={{
        padding: theme.spacing(4),
        width: '100%'
      }}
    >
      <Stack
        direction="column"
        sx={{
          px: '16px',
          mb: { xs: '32px', md: '56px', lg: '96px' },
          maxWidth: '1035px',
          mx: {
            xs: theme.spacing(4),
            md: 'auto'
          },
          p: dark ? { xs: '35px 0px', md: '35px 8px', lg: '55px' } : { xs: '0px' },
          borderRadius: '12px',
          backgroundColor: dark ? theme.palette.primary.dark : theme.palette.primary.light
        }}
        spacing={theme.spacing(8)}
        id={sectionId}
      >
        <Box sx={theme => ({ maxWidth: theme.spacing(216.5), mx: 'auto' })}>
          <Typography variant={'headlineSmall'} color="white" textAlign="center">
            {data.primary?.subheader}
          </Typography>
        </Box>
        {data.primary?.image && (
          <Image
            data-testid={data.primary.image.alt}
            key={data.primary.image.alt}
            width={1920}
            height={1344}
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'contain'
            }}
            src={data.primary.image.url ?? ''}
            alt={data.primary.image.alt ?? ''}
            loading={'lazy'}
          />
        )}
      </Stack>
    </Box>
  )
}

export default UsedBySection
